import { getQueryKeys } from "../../helper";

const namespace = "wallets";

export default {
  ...getQueryKeys(namespace),
};
